import {FormDrawer} from "./FormDrawer.tsx";
import {DrawerProps} from "@mantine/core";
import {useProductFeature} from "../hooks/useProductFeature.ts";
import {ProductFeature} from "../types.ts";

// No `id`: CreateProductFeatureInput does not declare one, and AppSync rejects the whole
// create for an undeclared field (FNP-1897). New features start as Draft; the status is
// set here, not chosen on the form.
const NEW_PRODUCT_FEATURE = {
    name: '',
    description: '',
    category: '',
    status: 'Draft',
} as ProductFeature;

export const AddFormDrawer = (props: DrawerProps) => {
    const {
        createRecord,
    } = useProductFeature();

    return (
        <FormDrawer
            record={NEW_PRODUCT_FEATURE}
            handleSubmit={createRecord}
            {...props}
        />
    )
};
